import { Collapse } from "antd";
import { FlexDiv, HorizontalFlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const ItemCard = styled(FlexDiv) <{ isEmbed?: boolean }>`
    width: 100%;
    min-height: 75px;
    border-radius: 8px;
    padding: 8px;
    box-shadow: ${props => props.isEmbed ? "none" : "0 3px 10px rgb(0 0 0 / 0.2)"};
    background-color: white;
    cursor: pointer;
`

export const TopContainer = styled(HorizontalFlexDiv)`
    gap: 8px;
    width: 100%;
`
export const BottomContainer = styled(HorizontalFlexDiv)`
    gap: 0px;
    margin-top: 8px;
    min-height: 35px;
`
export const ImageContainer = styled(FlexDiv)`
    width: 60px;
`

export const ItemImageContainer = styled(FlexDiv)`
    width: 60px;
    height: 60px;
    border: 1px solid black;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border-color: #eee;
`

export const DescriptionContainer = styled(FlexDiv)`
    flex: 1;
    gap: 0px;
    justify-content: center;
`

export const ItemId = styled.label`
    color: gray;
    font-size: 12px;
`
export const ItemDescription = styled.label`
    font-weight: bold;
    font-size: 14px;
`
export const ItemPrice = styled.label`
    font-weight: bold;
    font-size: 14px;
`
export const ActionsContainer = styled(FlexDiv)`
    width: 100px;
    justify-content: space-between;
    align-items: end;
    padding-top: 4px;
    padding-bottom: 8px;
`
export const SectionContainer = styled(HorizontalFlexDiv) <{ side: "LEFT" | "RIGHT" }>`
    width: ${props => props.side === "LEFT" ? '70%' : '30%'};
    justify-content: ${props => props.side === "LEFT" ? 'start' : 'end'};
    gap: 12px;
    align-items: center;
`
export const CharCollapse = styled(Collapse)`
    .ant-collapse-content-box {
        padding-block: 0 !important;
    }
`